/* eslint-disable max-len */
export const categoryPickerMockData = [
  {
    id: 105012,
    brand: 'Apple',
    model: 'iPhone 15 Pro Max',
    category: 'SMARTPHONE',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/smartphone-images%2Fiphone-15-pro-max%2Fnt%2F1.jpg?alt=media&token=b9132d97-66b0-4ca0-9346-5b3cb0727d3e',
    price: {
      amount: 119,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 7149,
      currency: 'SAR',
    },
    inStock: true,
  },
  {
    id: 100526,
    brand: 'Apple',
    model: 'MacBook Air 13.3" (Mid-2020)',
    category: 'LAPTOP',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/laptop-images%2FMacBook-Air-A2179-(2020)%2FSpace%20Gray%2F1.jpg?alt=media&token=7b0e1098-4088-4d4f-ac19-77460bab34f1&_gl=1*1gkyvp8*_ga*NzEzOTk2Mzc5LjE2ODQ0MTI1OTY.*_ga_CW55HF8NVT*MTY4NjU5NDUzMy44LjEuMTY4NjU5NjY5NC4wLjAuMA..',
    price: {
      amount: 589,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 4799,
      currency: 'SAR',
    },
    inStock: true,
  },
  {
    id: 101925,
    brand: 'Apple',
    model: 'iPad 9.7 (2018)',
    category: 'TABLET',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/smartphone-images%2Fipad%209-7-2018%2Fsg%2F1.jpg?alt=media&token=472c9710-8acf-46a4-ab08-7fdc388205ca',
    price: {
      amount: 449,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 1129,
      currency: 'SAR',
    },
    inStock: true,
  },
  {
    id: 102371,
    brand: 'Apple',
    model: 'Watch Series 6 Aluminium (GPS) 40mm',
    category: 'WATCH',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Smartphone%20Images%2FWatch%20series%2FWatch%20Series%206%20Aluminium%20(%20GPS%20%2B%20Cellular%20)%2FSliver%2F1.jpg?alt=media&token=dbbb07ed-9f2e-496d-ac60-ba4a006f3834',
    price: {
      amount: 839,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 1339,
      currency: 'SAR',
    },
    inStock: true,
  },
  {
    id: 102187,
    brand: 'Apple',
    model: 'Earpods with Lightning Connector',
    category: 'HEADPHONES',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Charger%2FEarpods%20Lightning%20Connector%2F1.jpg?alt=media&token=1e06cbf3-bfdd-429a-b694-28cd6078b456',
    price: {
      amount: 299,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 719,
      currency: 'SAR',
    },
    inStock: true,
  },
  {
    id: 102186,
    brand: 'Apple',
    model: 'MAGSAFE Charger',
    category: 'ACCESSORIES',
    image:
      'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Charger%2FMAGSAFE%20Charger%2F1.jpg?alt=media&token=6f8addcc-752a-4cf8-a366-f6cf1afc074d',
    price: {
      amount: 299,
      currency: 'SAR',
    },
    originalPrice: {
      amount: 719,
      currency: 'SAR',
    },
    inStock: true,
  },
];
